import './_Location.scss'
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import maps from "../../../assets/images/maps.png"
import SubscribeSection from "../../section/home/subscribe/SubscribeSection";
import WriteMessage from "../../section/home/writeMessage/writeMessage";

const Location = () => {

    return (<>
            <Header/>
            <div className='location-box'>
                <div className='container'>
                    <div className='crumbs'>
                        <p><a href="/">Home</a> / <span>Location</span></p>
                    </div>
                    <div className='container-content'>
                        <div className='left-box'>
                            <div>
                                <h4>PivotHawk Gem, AB</h4>
                                <p>163077B Township Rd 232, Newell County No. 4,<br/>
                                    AB T0J 1M0, Canada
                                    <br/>
                                </p>
                                <img src={maps} alt="maps"/>
                            </div>
                        </div>
                        <div className='right-box'>
                            <WriteMessage/>
                        </div>
                    </div>

                </div>
            </div>
            <Footer/>
        </>
    );
};

export default Location
